import axios from 'axios';
import {
	GET_CATEGORIES_SUCCESS,
	GET_CATEGORIES_FAILED,
	SET_ALERT,
	CREATE_CATEGORY_SUCCESS,
	CREATE_CATEGORY_FAILED,
	UPDATE_CATEGORY_SUCCESS,
	UPDATE_CATEGORY_FAILED,
	DELETE_CATEGORY_FAILED,
	DELETE_CATEGORY_SUCCESS
} from './index';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const getAllCategories = () => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.get(BASE_URL + '/api/get-categories', config);
		dispatch({ type: GET_CATEGORIES_SUCCESS, payload: response.data });
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to retrieve facility', status: 'error' },
		});
		dispatch({
			type: GET_CATEGORIES_FAILED,
		});
	}
};

export const createCategory = (formData) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
			'content-type': 'multipart/form-data'
		},
	};
	// const body = Object.fromEntries(formData.entries());
	// console.log(body);
	try {
		const response = await axios.post(
			BASE_URL + '/api/create-category',
			formData,
			config
		);
		console.log(response.data);
		dispatch({ type: CREATE_CATEGORY_SUCCESS, payload: response.data });
		dispatch({
			type: SET_ALERT,
			payload: {
				message: 'Category created successfully!',
				status: 'success',
			},
		});
	} catch (e) {
		console.log(e);
		dispatch({ type: CREATE_CATEGORY_FAILED });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to create category', status: 'error' },
		});
		throw e;
	}
};

export const updateCategory = (categoryId, formData) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
			// Let browser set content-type for multipart/form-data
		},
	};
	try {
		const response = await axios.put(
			`${BASE_URL}/api/update-category/${categoryId}`,
			formData,
			config
		);
		dispatch({ type: UPDATE_CATEGORY_SUCCESS, payload: response.data });
		dispatch({
			type: SET_ALERT,
			payload: {
				message: 'Category updated successfully!',
				status: 'success',
			},
		});
	} catch (e) {
		console.error(e);
		dispatch({ type: UPDATE_CATEGORY_FAILED });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to update category', status: 'error' },
		});
		throw e;
	}
};

export const deleteCategory = (categoryId) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
			// Let browser set content-type for multipart/form-data
		},
	};
	try {
		console.log(categoryId)
		const response = await axios.put(
			`${BASE_URL}/api/delete-category/${categoryId}`,{},
			config
		);
		console.log(response.data)
		dispatch({ type: DELETE_CATEGORY_SUCCESS, payload: response.data });
		dispatch({
			type: SET_ALERT,
			payload: {
				message: 'Category updated successfully!',
				status: 'success',
			},
		});
	} catch (e) {
		console.error(e);
		dispatch({ type: DELETE_CATEGORY_FAILED });
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Failed to update category', status: 'error' },
		});
		throw e;
	}
};
